import React, { useState } from 'react';
import AddCharge from '../AddEdit/AddCharge';
import EditCharge from '../AddEdit/EditCharge';

const HBLClausesTab = () => {
    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = () => setShowEdit(true);

    return (
        <>
            <form>
        <div className="row border-bottom-2 pb-3">

                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Age of Vessel</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Caribbean Basin Initiative (CBI)</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Carrier Reserves the Right to Place Container(s) in Heated Warehouse at a Set Cost</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Certification Statements</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Container Packing Certificate</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Container Safety Act</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Container(s) Sealed by Shipper</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Cool Cargo</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Custom</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Delivery Order Liability Clause</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Destination Control Statements</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Destination Country Final destination of the shipment</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">	Disclaimer</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Emergency Response Statement</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Freeze Cargo</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Freight as Agreed</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Freight Collect</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Freight Prepaid</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">General Agreement on Tariff and Trade (GATT)</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">General System of Preferences (GSP)</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Inland Transportation Arranged as Agents Only with such Arranged Transportation Being Solely for Account and Risk of Cargo</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">International Maritime Organization Certification</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Israeli Free Trade Agreement</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Laden on Board</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Laden on Board Named Vessel</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Laden on Board Vessel</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Memo Bill of Lading Only</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">No Shipper's Export Declaration Required (Section 30.39)</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">North American Free Trade Agreement (NAFTA)</label> 
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">On Board Container</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">On Board Rail</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">On Board Truck</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">On Board Vessel</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">On Deck at Shipper's Risk</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Prior Damage Remarks</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Producing Country of Origin</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Received For Shipment</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Refrigerated Cargo</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Sea Waybill</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Sea-Air Cargo</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Shipper's Load and Count</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Shipper's Load, Stowage and Count</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Short-Shipped</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">	This Shipment is Effected under a Sea Waybill</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Title Passage Clause</label>
                        </div>
                </div>
                    <div className="col-md-12">
                        <div className='d-flex'>
                        <input type="checkbox" className='ms-2'/>
                        <label htmlFor=""  className="form-label ms-2">Vessel Not Responsible for Freezing</label>
                        </div>
                </div>
        </div>

    </form>

            {showAdd && <AddCharge showAdd={showAdd} handleCloseAdd={handleCloseAdd} />}
            {showEdit && <EditCharge showEdit={showEdit} handleCloseEdit={handleCloseEdit} />}
        </>
    );
};

export default HBLClausesTab
